import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import s from './CommentsRangeContainer.module.scss';

const CommentRangeSlider = (props) => {
  const {
    marginLeft,
    marginRight,
    handleMouseDownCommentRangeEnd,
    handleMouseDownCommentRangeStart,
    noProofingAccess,
    isHidden = true,
  } = props;

  if (noProofingAccess) {
    return null;
  }

  return (
    <div className={cn(s.commentsRangeContainer, { [s.hidden]: isHidden })}>
      <div style={{ marginRight, marginLeft }} className={s.commentsRangeControls}>
        <div
          className={cn(s.control, s.left)}
          onMouseDown={handleMouseDownCommentRangeStart}
          role="presentation"
        >
          [
        </div>
        <div className={s.commentsRangeIndicatorContainer}>
          <div className={s.dot} />
          <div className={s.commentIndicator} />
        </div>
        <div
          className={cn(s.control, s.right)}
          onMouseDown={handleMouseDownCommentRangeEnd}
          role="presentation"
        >
          ]
        </div>
      </div>
    </div>
  );
};

CommentRangeSlider.propTypes = {
  isHidden: PropTypes.bool,
  marginLeft: PropTypes.number.isRequired,
  marginRight: PropTypes.number.isRequired,
  handleMouseDownCommentRangeEnd: PropTypes.func.isRequired,
  handleMouseDownCommentRangeStart: PropTypes.func.isRequired,
  noProofingAccess: PropTypes.bool.isRequired,
};

CommentRangeSlider.defaultProps = {
  isHidden: true,
};

export default CommentRangeSlider;
